import { PaginationFilterRequest } from "./core.model";

export interface AdvanceShareStyle {
    id: number;
    name: string;
    coverImageUrl?: string;
    category: AdvanceShareStyleCategoryEnum;
    status: AdvanceShareStyleStatusEnum;
    currentVersionId?: number;
    currentVersionNo?: number;
}

export interface UpsertAdvanceShareStyle {
    id?: number;
    name?: string;
    coverImageUrl?: string;
    category?: AdvanceShareStyleCategoryEnum;
}


export class AdvanceShareStylePaginationFilterRequest extends PaginationFilterRequest{  
    category?: AdvanceShareStyleCategoryEnum;
    status?: AdvanceShareStyleStatusEnum;
}

export enum AdvanceShareStyleCategoryEnum
{
    Sport = 1,
    Club = 2,
    Marathon = 3,
    // Captain profile-picture styles. The mobile app lists this category
    // verbatim on its AI profile picture wizard, so anything published under it
    // shows up there.
    RunClubProfile = 4,
    // Runner DNA character styles, listed by the app's Runner DNA result screen.
    RunnerDna = 5,
}
export const AdvanceShareStyleCategoryList = 
[
    { value: 1, label: "Sport" },
    { value: 2, label: "Club" },
    { value: 3, label: "Marathon" },
    { value: 4, label: "Run Club Profile" },
    { value: 5, label: "Runner DNA" },
];


export enum AdvanceShareStyleStatusEnum
{
    Draft = 1,
    Published = 2,
    Archived = 3,
}

export const AdvanceShareStyleStatusList = 
[
    { value: 1, label: "Draft" },
    { value: 2, label: "Published" },
    { value: 3, label: "Archived" },
];